import Modal from "../../Modal"
import { TadaPoints } from '../../Modal/styled';

const RevGenWelcomeModal = () => {
	return (
		<Modal title="Account Connected Successfully!">
			<TadaPoints>
				<li>Your Laterpay 2.0 account has been successfully connected</li>
				<li>Your users now have a frictionless on-page purchase process</li>
			</TadaPoints>

			<p>Feel free to reach out to your sales person or to <a href="mailto:wordpress@laterpay.net">wordpress@laterpay.net</a> with questions or feedback.</p>

			<p>Thanks, The Laterpay Team</p>
		</Modal>
	)
}

export default RevGenWelcomeModal;
